import cx from 'classnames';
import type { VoidFunctionComponent } from 'react';

import type { ReleaseGroupState } from '../../hooks/useReleaseGroupState';

import ReleaseGroupsSaveCancelButtons from './ReleaseGroupsHeader/ReleaseGroupsSaveCancelButtons';

import styles from '../ReleaseGroupsRevamp.module.less';

type Props = {
  saveButtonText: string;
  cancelButtonText?: string;
  validationErrors: ReturnType<ReleaseGroupState['validate']>;
  isLoading?: boolean;
  onCancel: () => void;
  onSave: () => void;
};

const ReleaseGroupsFooter: VoidFunctionComponent<Props> = (props) => {
  return (
    <div className={cx(styles.section, styles.footer)}>
      <ReleaseGroupsSaveCancelButtons {...props} />
    </div>
  );
};

export default ReleaseGroupsFooter;
